<mat-card role="button">
  <mat-card-title>
    {{ title() ?? item().label }}
  </mat-card-title>

  @if (chevron()) {
    <ui-icon faName="chevron-right" faStyle="light"></ui-icon>
  }

  @if (mode() === 'link') {
    <a uiNavLink [link]="item()"></a>
  }
</mat-card>
